import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Navbar from "./components/Header/Navbar";
import LandingPage from "./pages/LandingPage";
import Footer from "./components/Footer/Footer";
import ContactSection from "./components/Contact/ContactSection";

import Home from "./components/Home/Home";
import About from "./components/About/About";
import OurServices from "./components/Services/Services";
import Careers from "./components/Careers/Careers";
import PortfolioHome from "./components/Portfolio/PortfolioHome";
import PlacementSection from "./components/PlacedStudents/PlacementSection";
import ScrollToTop from "./components/ToptoBack/ScrollToTop";
import TransportManagement from "./components/Products/TransportManagement";
import InvoiceBalancing from "./components/Products/InvoiceBalancing";
import School from "./components/Products/School";
import SchoolERP from "./components/Products/SchoolERP";
import Transport from "./components/Products/Transport";
import Invoice from "./components/Products/Invoice";
import ECommerceSolution from "./components/Products/ECommerceSolution";
import ECommerceDetails from "./components/Products/ECommerceDetails";
import ClinicManagement from "./components/Products/ClinicManagement";
import LeadManagement from "./components/Products/LeadManagementMain";
import LeadManage from "./components/Products/Leadmanagement";
import Login from "./components/Login/Login";
import Client from "./components/Products/ClientManagement";
import QRAttendance from "./components/Products/QRAttendance";
import QRA from "./components/Products/QRA";

// Private Route
import PrivateRoute from "./Routes/PrivateRoute"

// Dashboard Page
import DashboardPage from "./pages/DashboardPage";
import Dashboard from "./Dashboard/dashbord/Dashboard";
import Contact from "./Dashboard/Contact/Contact";
import ProductEnquiries from "./Dashboard/ProductEnquiries/ProductEnquiries";

const MainLayout = () => {
  return (
    <>
      <Navbar />
      <LandingPage />
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        {/* for landingpage */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<OurServices />} />
          <Route path="TransportManagement" element={<TransportManagement />} />
          <Route path="invoice-balancing" element={<InvoiceBalancing />} />
          <Route path="School" element={<School />} />
          <Route path="Ecommerce" element={<ECommerceSolution />} />
          <Route path="Clinic" element={<ClinicManagement />} />
          <Route path="lead" element={<LeadManagement />} />
          <Route path="QRAttendance" element={<QRAttendance />} />
          <Route path="careers" element={<Careers />} />
          <Route path="portfolio" element={<PortfolioHome />} />
          <Route path="internship" element={<PlacementSection />} />
          <Route path="contact" element={<ContactSection />} />
        </Route>

        {/* For dashboardpage */}
        <Route path="/admin" element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="contact" element={<Contact />} />
          <Route path="product-enquiries" element={<ProductEnquiries />} />
        </Route>

        {/* Landing Page others routes */}
        <Route path="/invoice-details" element={<Invoice />} />
        <Route path="/school-details" element={<SchoolERP />} />
        <Route path="/transport-details" element={<Transport />} />
        <Route path="/lead-details" element={<LeadManage />} />
        <Route path="/ecommerce-details" element={<ECommerceDetails />} />
        <Route path="/clinic-details" element={<Client />} />
        <Route path="/qr-attendance" element={<QRA />} />
        <Route path="/login" element={<Login />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;